var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hotel-category-component flex space-x-2"},_vm._l((_vm.stars),function(star){return _c('img',{key:star,attrs:{"src":"/img/icons/star.svg"}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }